import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Alert, Card } from "react-bootstrap";
import headerImage from "../img/header.png";

export class Start extends AbstractStep {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Img src={headerImage} variant="top" width="360" height="232" />
				<Card.Body>
					<div className="h3 font-weight-bolder text-center text-secondary text-uppercase mt-3">
						<mark className="bg-secondary text-white">Széchenyi hitel</mark>
					</div>
					<Alert variant="warning" className="mb-0 mt-4">
						<p>
							<strong>NHP Hajrá!</strong> konstrukció <strong>keretösszege kimerült</strong>, a termék{" "}
							<strong>nem elérhető!</strong>
						</p>
						<p className="mb-0">
							Ha támogatott hitelben gondolkodsz, a <strong>KAVOSZ Széchenyi Kártya Programját</strong>{" "}
							ajánljuk!
						</p>
					</Alert>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button
						href="/vallalati/hitel/szechenyi-hitel/"
						target="_blank"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						onClick={() => this.sendEvent("BM_openCalculator")}
					>
						Ugrás a kalkulátorra
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Start";
	}
}
